import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/certificate',
    name: 'certificate',
    component: () => import('../views/Certificate.vue')
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('../views/Signup.vue')
  },
  {
    path: '/index',
    redirect: '/'
  },
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/Index.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/guide',
    name: 'guide',
    component: () => import('../views/Guide.vue')
  },
  {
    path: '/honor',
    name: 'honor',
    component: () => import('../views/Honor.vue')
  },
  {
    path: '/rank',
    name: 'rank',
    component: () => import('../views/Rank.vue')
  },
  {
    path: '/terminal',
    name: 'terminal',
    component: () => import('../views/Terminal.vue')
  },
  {
    path: '/info',
    name: 'info',
    component: () => import('../views/Info.vue')
  },
  {
    path: '/info/data',
    redirect: '/info'
  },

  {
    path: '/thanks',
    name: 'thanks',
    component: () => import('../views/Thanks.vue')
  },
  {
    path: '/manage',
    name: 'manage',
    component: () => import('../views/Manage.vue')
  },
  {
    path: '/main',
    name: 'main',
    component: () => import('../views/Main.vue'),
    children: [
      {
        path: '/funds',
        name: 'funds',
        component: () => import('../views/Funds.vue')
      },
      {
        path: '/workshop',
        name: 'workshop',
        component: () => import('../views/Workshop.vue')
      },
      {
        path: '/sell/:id',
        name: 'sell',
        component: () => import('../views/Sell.vue')
      },
      {
        path: '/process/:id',
        name: 'process',
        component: () => import('../views/Process.vue')
      },
      {
        path: '/order',
        name: 'order',
        component: () => import('../views/Order.vue')
      },
      {
        path: '/market',
        name: 'market',
        component: () => import('../views/Market.vue')
      },
      {
        path: '/productivity',
        name: 'productivity',
        component: () => import('../views/Productivity.vue')
      },
      {
        path: '/intelligence',
        name: 'intelligence',
        component: () => import('../views/Intelligence.vue')
      }
    ]
  },
  {
    path: '/show',
    name: 'show',
    component: () => import('../views/Show.vue')
  },
  {
    path: '/data',
    name: 'data',
    component: () => import('../views/Data.vue')
  },
  {
    path: '/assignment',
    name: 'assignment',
    component: () => import('../views/Assignment.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
